import { styled } from '@lichtblick/styled';
import { BorderRadius, Colors } from '@lichtblick/theme';

export const Container = styled.div<{ $isCraftsman: boolean }>`
  align-items: center;

  background-color: ${({ $isCraftsman }) => ($isCraftsman ? Colors.gray[100] : Colors.green[100])};
  border-radius: ${BorderRadius.Full};
  display: flex;
  height: 2.5rem;
  justify-content: center;
  width: 2.5rem;

  > svg {
    color: ${Colors.white};
  }
`;
